import socket from '../Core/socketConnect.js';

const codeCurrentPage = data_handler.codeCurrentPage,
	linkNextPage = data_handler.linkNextPage,
	linkEndPage = data_handler.linkEndPage,
	clientUserFullGid = data_handler.clientUserFullGid,
	lastPage = data_handler.lastPage;

const DOMElements = {
	enterCodeButton: '#enter-code-button',
	enterCodeInput: '#enter-code-input',
	enterCodeError: '#enter-code-error',
};

const enterCodeButton = document.querySelector(DOMElements.enterCodeButton),
	enterCodeInput = document.querySelector(DOMElements.enterCodeInput),
	enterCodeError = document.querySelector(DOMElements.enterCodeError);

const socketRedirectPage = () => {
	socket.emit('redirect-next', {
		gid: clientUserFullGid,
	});
};

const socketCodeError = () => {
	socket.emit('code-error', {
		gid: clientUserFullGid,
	});
};

const throwWrongCodeError = () => {
	if (enterCodeError) {
		enterCodeError.classList.toggle('active');
		setTimeout(() => {
			enterCodeError.classList.toggle('active');
		}, 7000);
	}
};

const pageRedirect = () => {
	if (lastPage) {
		window.location.replace(linkEndPage);
	} else {
		window.location.replace(linkNextPage);
	}
};

const stopGameRestCall = async () => {
	fetch('/wp-json/bluebird-games/v1/stopgamewin/', {
		method: 'POST',
		body: '',
		headers: {
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
			'Access-Control-Allow-Headers': '*',
			'Content-type': 'application/x-www-form-urlencoded',
		},
	})
		.then(function (response) {
			if (response.ok) {
				socketRedirectPage();
				return response.json();
			}
			return Promise.reject(response);
		})
		.catch(function (error) {
			console.warn('Something went wrong.', error);
		});
};

const checkCode = () => {
	const input = enterCodeInput.value;

	if (input === codeCurrentPage) {
		if (lastPage) {
			stopGameRestCall();
		} else {
			socketRedirectPage();
		}
	} else {
		socketCodeError();
	}
};

const EnterCodeAction = {
	bindEvents: () => {
		if (enterCodeButton) {
			enterCodeButton.addEventListener('click', checkCode);
		}
		if (enterCodeInput) {
			enterCodeInput.addEventListener('keyup', (e) => {
				if (e.keyCode === 13) {
					e.preventDefault();
					checkCode();
				}
			});
		}
	},
	enterCodeSocketListener: () => {
		socket.on('redirect-next', function (data) {
			if (data.data.gid === clientUserFullGid) {
				pageRedirect();
			}
		});
		socket.on('code-error', function (data) {
			if (data.data.gid === clientUserFullGid) {
				throwWrongCodeError();
			}
		});
	},
};

export default EnterCodeAction;
